module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Thin-a837dfff57b9142fb6f7e726ff21a4aa.ttf";